import { Card, ContentSectionBlock, Link, List, ListItem } from 'camino-react'
import { map } from 'lodash'
import React from 'react'

const AssociatedChangeRequests = ({ changeRequests, hidden }) => {
  if (hidden) {
    return null
  }

  return (
    <Card allowOverflow padding={false}>
      <ContentSectionBlock title='Associated Change Requests'>
        <List>
          {map(changeRequests, changeRequest => (
            <ListItem>
              <div className="flex-1">
                  <Link href={changeRequest.href}>
                    <span className="flex-1 duration-300 text-blue-500 hover:text-blue-700 hover:underline">
                      {changeRequest.id_with_title}
                    </span>
                  </Link>
                </div>
            </ListItem>
          ))}
        </List>
      </ContentSectionBlock>
    </Card>
  )
}

export default AssociatedChangeRequests